import { createFileRoute } from '@tanstack/react-router'
import { IncidentMappingTab } from '@/features/incidents/reports/incident-mapping/incident-mapping-tab'

export const Route = createFileRoute(
  '/_authenticated/_organization/incidents/reports/incident-mapping'
)({
  component: IncidentMappingTab,
})
